import React, { useState } from "react";
import { useParams } from "react-router-dom";
import MainCalculatorsList from "../MainCalculators";
import SharedHelmet from "../../Helmet";
import RelatedLinks from "../../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../../Ads";
function VitaminDoseCalculator() {
  const { vitamin } = useParams();
  const [age, setAge] = useState("");
  const [sex, setSex] = useState("male");
  const [isPregnant, setIsPregnant] = useState(false);
  const [isLactating, setIsLactating] = useState(false);
  const [dose, setDose] = useState(null);
  const [error, setError] = useState("");
  const vitaminNames = {
    a: "Vitamine A", c: "Vitamine C", d: "Vitamine D", e: "Vitamine E", k: "Vitamine K",
    b1: "Thiamine (B1)", thiamin: "Thiamine (B1)",
    b2: "Riboflavine (B2)", riboflavin: "Riboflavine (B2)",
    b3: "Niacine (B3)", niacin: "Niacine (B3)",
    b5: "Acide pantothénique (B5)", pantothenic_acid: "Acide pantothénique (B5)",
    b6: "Pyridoxine (B6)", pyridoxine: "Pyridoxine (B6)",
    b7: "Biotine (B7)", biotin: "Biotine (B7)",
    b9: "Acide folique (B9)", folate: "Acide folique (B9)",
    b12: "Cobalamine (B12)", caynocobalamin: "Cobalamine (B12)",
    choline: "Choline",
  };
  const vitaminUnits = {
    a: "µg", c: "mg", d: "µg", e: "mg", k: "µg",
    b1: "mg", thiamin: "mg", b2: "mg", riboflavin: "mg",
    b3: "mg", niacin: "mg", b5: "mg", pantothenic_acid: "mg",
    b6: "mg", pyridoxine: "mg", b7: "µg", biotin: "µg",
    b9: "µg", folate: "µg", b12: "µg", caynocobalamin: "µg",
    choline: "mg",
  };
  const normalizedVitamin = vitamin.toLowerCase();
  const vitaminName = vitaminNames[normalizedVitamin] || vitamin;
  const vitaminUnit = vitaminUnits[normalizedVitamin] || "µg";
  const vitaminKeyMap = {
    a: "A", c: "C", d: "D", e: "E", k: "K",
    b1: "B1", thiamin: "B1", b2: "B2", riboflavin: "B2",
    b3: "B3", niacin: "B3", b5: "B5", pantothenic_acid: "B5",
    b6: "B6", pyridoxine: "B6", b7: "B7", biotin: "B7",
    b9: "B9", folate: "B9", b12: "B12", caynocobalamin: "B12",
    choline: "Choline",
  };
  const vitaminKey = vitaminKeyMap[normalizedVitamin] || "A";
  const getVitaminDose = (vitKey, ageValue, gender, pregnant, lactating) => {
    const dosageTable = {
      A: {
        male: { "0-6m": 400, "7-12m": 500, "1-3y": 300, "4-8y": 400, "9-13y": 600, "14-18y": 900, "19-50y": 900, "51+y": 900 },
        female: { "0-6m": 400, "7-12m": 500, "1-3y": 300, "4-8y": 400, "9-13y": 600, "14-18y": 700, "19-50y": 700, "51+y": 700 },
        pregnant: 770, lactating: 1300,
      },
      C: {
        male: { "0-6m": 40, "7-12m": 50, "1-3y": 15, "4-8y": 25, "9-13y": 45, "14-18y": 75, "19-50y": 90, "51+y": 90 },
        female: { "0-6m": 40, "7-12m": 50, "1-3y": 15, "4-8y": 25, "9-13y": 45, "14-18y": 65, "19-50y": 75, "51+y": 75 },
        pregnant: 85, lactating: 120,
      },
      D: {
        male: { "0-6m": 10, "7-12m": 10, "1-3y": 15, "4-8y": 15, "9-13y": 15, "14-18y": 15, "19-50y": 15, "51-70y": 15, "71+y": 20 },
        female: { "0-6m": 10, "7-12m": 10, "1-3y": 15, "4-8y": 15, "9-13y": 15, "14-18y": 15, "19-50y": 15, "51-70y": 15, "71+y": 20 },
        pregnant: 15, lactating: 15,
      },
      E: {
        male: { "0-6m": 4, "7-12m": 5, "1-3y": 6, "4-8y": 7, "9-13y": 11, "14-18y": 15, "19-50y": 15, "51+y": 15 },
        female: { "0-6m": 4, "7-12m": 5, "1-3y": 6, "4-8y": 7, "9-13y": 11, "14-18y": 15, "19-50y": 15, "51+y": 15 },
        pregnant: 15, lactating: 19,
      },
      K: {
        male: { "0-6m": 2, "7-12m": 2.5, "1-3y": 30, "4-8y": 55, "9-13y": 60, "14-18y": 75, "19-50y": 120, "51+y": 120 },
        female: { "0-6m": 2, "7-12m": 2.5, "1-3y": 30, "4-8y": 55, "9-13y": 60, "14-18y": 75, "19-50y": 90, "51+y": 90 },
        pregnant: 90, lactating: 90,
      },
      B1: {
        male: { "0-6m": 0.2, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.2, "19-50y": 1.2, "51+y": 1.2 },
        female: { "0-6m": 0.2, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.0, "19-50y": 1.1, "51+y": 1.1 },
        pregnant: 1.4, lactating: 1.4,
      },
      B2: {
        male: { "0-6m": 0.3, "7-12m": 0.4, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.3, "19-50y": 1.3, "51+y": 1.3 },
        female: { "0-6m": 0.3, "7-12m": 0.4, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 0.9, "14-18y": 1.0, "19-50y": 1.1, "51+y": 1.1 },
        pregnant: 1.4, lactating: 1.6,
      },
      B3: {
        male: { "0-6m": 2, "7-12m": 4, "1-3y": 6, "4-8y": 8, "9-13y": 12, "14-18y": 16, "19-50y": 16, "51+y": 16 },
        female: { "0-6m": 2, "7-12m": 4, "1-3y": 6, "4-8y": 8, "9-13y": 12, "14-18y": 14, "19-50y": 14, "51+y": 14 },
        pregnant: 18, lactating: 17,
      },
      B6: {
        male: { "0-6m": 0.1, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 1.0, "14-18y": 1.3, "19-50y": 1.3, "51-70y": 1.7, "71+y": 1.7 },
        female: { "0-6m": 0.1, "7-12m": 0.3, "1-3y": 0.5, "4-8y": 0.6, "9-13y": 1.0, "14-18y": 1.2, "19-50y": 1.3, "51-70y": 1.5, "71+y": 1.5 },
        pregnant: 1.9, lactating: 2.0,
      },
      B9: {
        male: { "0-6m": 65, "7-12m": 80, "1-3y": 150, "4-8y": 200, "9-13y": 300, "14-18y": 400, "19-50y": 400, "51+y": 400 },
        female: { "0-6m": 65, "7-12m": 80, "1-3y": 150, "4-8y": 200, "9-13y": 300, "14-18y": 400, "19-50y": 400, "51+y": 400 },
        pregnant: 600, lactating: 500,
      },
      B12: {
        male: { "0-6m": 0.4, "7-12m": 0.5, "1-3y": 0.9, "4-8y": 1.2, "9-13y": 1.8, "14-18y": 2.4, "19-50y": 2.4, "51+y": 2.4 },
        female: { "0-6m": 0.4, "7-12m": 0.5, "1-3y": 0.9, "4-8y": 1.2, "9-13y": 1.8, "14-18y": 2.4, "19-50y": 2.4, "51+y": 2.4 },
        pregnant: 2.6, lactating: 2.8,
      },
      B5: {
        male: { "0-6m": 1.7, "7-12m": 1.8, "1-3y": 2, "4-8y": 3, "9-13y": 4, "14-18y": 5, "19-50y": 5, "51+y": 5 },
        female: { "0-6m": 1.7, "7-12m": 1.8, "1-3y": 2, "4-8y": 3, "9-13y": 4, "14-18y": 5, "19-50y": 5, "51+y": 5 },
        pregnant: 6, lactating: 7,
      },
      B7: {
        male: { "0-6m": 5, "7-12m": 6, "1-3y": 8, "4-8y": 12, "9-13y": 20, "14-18y": 25, "19-50y": 30, "51+y": 30 },
        female: { "0-6m": 5, "7-12m": 6, "1-3y": 8, "4-8y": 12, "9-13y": 20, "14-18y": 25, "19-50y": 30, "51+y": 30 },
        pregnant: 30, lactating: 35,
      },
      Choline: {
        male: { "0-6m": 125, "7-12m": 150, "1-3y": 200, "4-8y": 250, "9-13y": 375, "14-18y": 550, "19-50y": 550, "51+y": 550 },
        female: { "0-6m": 125, "7-12m": 150, "1-3y": 200, "4-8y": 250, "9-13y": 375, "14-18y": 400, "19-50y": 425, "51+y": 425 },
        pregnant: 450, lactating: 550,
      },
    };
    let ageCategory;
    const ageNum = parseInt(ageValue);
    if (ageNum < 1) { ageCategory = ageNum < 0.5 ? "0-6m" : "7-12m"; }
    else if (ageNum <= 3) { ageCategory = "1-3y"; }
    else if (ageNum <= 8) { ageCategory = "4-8y"; }
    else if (ageNum <= 13) { ageCategory = "9-13y"; }
    else if (ageNum <= 18) { ageCategory = "14-18y"; }
    else if (ageNum <= 50) { ageCategory = "19-50y"; }
    else if (ageNum <= 70) { ageCategory = "51-70y" in dosageTable[vitKey][gender] ? "51-70y" : "51+y"; }
    else { ageCategory = "71+y" in dosageTable[vitKey][gender] ? "71+y" : "51+y"; }
    if (gender === "female" && pregnant) return dosageTable[vitKey].pregnant;
    if (gender === "female" && lactating) return dosageTable[vitKey].lactating;
    return dosageTable[vitKey][gender][ageCategory];
  };
  const calculateDailyDose = () => {
    try {
      if (!age || age < 0 || age > 120) {
        setError("Veuillez entrer un âge valide (0-120 ans)");
        setDose(null);
        return;
      }
      const calculatedDose = getVitaminDose(vitaminKey, age, sex, isPregnant, isLactating);
      setDose(calculatedDose);
      setError("");
    } catch (err) {
      setDose(null);
      setError("Une erreur est survenue lors du calcul. Veuillez vérifier les données saisies.");
    }
  };
  const handleCalculate = (e) => {
    e.preventDefault();
    calculateDailyDose();
  };
  const handleReset = () => {
    setAge("");
    setSex("male");
    setIsPregnant(false);
    setIsLactating(false);
    setDose(null);
    setError("");
  };
  const TITLE = `Calculatrice ${vitaminName} - Calculez votre dose quotidienne de ${vitaminName}`;
  const DESCRIPTION = `Calculez la dose quotidienne optimale de ${vitaminName} selon l'âge et le sexe avec notre calculatrice précise. La calculatrice de ${vitaminName} vous fournit la dose appropriée pour les hommes, les femmes, les enfants, les femmes enceintes et allaitantes pour assurer une bonne santé.`;
  const KEYWORDS = `dose quotidienne ${vitaminName}, besoins en ${vitaminName}, calculatrice ${vitaminName}, ${vitaminName} femme enceinte, ${vitaminName} enfants, carence ${vitaminName}, sources ${vitaminName}`;
  const OG_URL = `https://do-calculate.com/calculator/fr/vitamin-daily-dose/${vitamin}/`;
  const generateSchemaData = () => {
    return [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Accueil", item: "https://do-calculate.com/" },
          { "@type": "ListItem", position: 2, name: "Calculatrices", item: "https://do-calculate.com/fr/all-calculators/" },
          { "@type": "ListItem", position: 3, name: "Calculatrice vitamines", item: "https://do-calculate.com/calculator/fr/vitamin-daily-dose/" },
          { "@type": "ListItem", position: 4, name: `Calculatrice ${vitaminName}`, item: OG_URL },
        ],
      },
    ];
  };
  const vitaminInfo = {
    a: {
      importance: "La vitamine A est essentielle pour une vision saine, notamment la vision nocturne. Elle renforce l'immunité et aide à maintenir la santé de la peau et des muqueuses. Elle joue également un rôle fondamental dans la croissance cellulaire et le renouvellement des tissus.",
      sources: "Carottes, patates douces, citrouilles, épinards, chou, brocoli, foie, œufs, lait, mangues, abricots, melon",
      deficiency: "Yeux secs, cécité nocturne, affaiblissement du système immunitaire, peau sèche, retard de croissance chez l'enfant, risque accru d'infections",
    },
    c: {
      importance: "La vitamine C est un puissant antioxydant qui aide à renforcer le système immunitaire et à protéger les cellules contre les dommages. Elle contribue à la production de collagène nécessaire à la santé de la peau, des vaisseaux sanguins et des os.",
      sources: "Oranges, citrons, pamplemousses, fraises, kiwis, goyaves, poivrons de couleur, brocoli, tomates, épinards",
      deficiency: "Saignement des gencives, cicatrisation lente, ecchymoses faciles, peau sèche, affaiblissement du système immunitaire, douleurs articulaires, dans les cas graves : scorbut",
    },
    d: {
      importance: "La vitamine D favorise l'absorption du calcium et du phosphore, ce qui aide à construire et maintenir des os et des dents sains. Elle joue un rôle important dans le renforcement du système immunitaire et la régulation de la croissance cellulaire.",
      sources: "Rayons du soleil (10-30 minutes par jour), poissons gras (saumon, thon, sardines), jaune d'œuf, lait enrichi, jus d'orange enrichi, champignons exposés aux UV",
      deficiency: "Fragilité et douleurs osseuses, ostéoporose, rachitisme chez l'enfant, faiblesse musculaire, fatigue chronique, dépression, affaiblissement du système immunitaire",
    },
    e: {
      importance: "La vitamine E est un puissant antioxydant qui protège les cellules des dommages causés par les radicaux libres. Elle contribue à maintenir la santé de la peau, des yeux et des cheveux. Elle joue un rôle dans le renforcement du système immunitaire.",
      sources: "Noix (amandes, noisettes, cacahuètes), graines (tournesol, citrouille), huiles végétales (olive, tournesol), épinards, brocoli, avocat, kiwi",
      deficiency: "Faiblesse musculaire, problèmes visuels, affaiblissement du système immunitaire, engourdissements et picotements dans les extrémités, dans les cas graves : dommages nerveux",
    },
    k: {
      importance: "La vitamine K est essentielle pour une coagulation normale du sang et la prévention des saignements excessifs. Elle joue un rôle important dans la santé osseuse en régulant le calcium et en renforçant la densité osseuse.",
      sources: "Légumes verts à feuilles (chou, épinards, laitue, brocoli, choux de Bruxelles), persil, coriandre, huiles végétales, foie, œufs, avocat",
      deficiency: "Saignements faciles et difficiles à arrêter, ecchymoses fréquentes, saignement des gencives, epistaxis, règles abondantes, dans les cas graves : saignement interne",
    },
    b1: {
      importance: "La thiamine (B1) est nécessaire à la conversion des glucides en énergie. Elle soutient le bon fonctionnement des nerfs et des muscles. Elle joue un rôle dans la croissance, le développement et le fonctionnement des cellules.",
      sources: "Céréales complètes, pain enrichi, pâtes, riz complet, porc, foie, légumineuses, noix, graines, poisson",
      deficiency: "Fatigue et faiblesse, perte d'appétit, confusion et pertes de mémoire, engourdissements dans les mains et les pieds, dans les cas graves : béribéri",
    },
    b2: {
      importance: "La riboflavine (B2) aide à convertir les aliments en énergie. Elle favorise la santé de la peau, des yeux et des nerfs. Elle joue un rôle dans la production de globules rouges.",
      sources: "Lait et produits laitiers, œufs, viandes maigres, foie, légumes verts à feuilles, céréales complètes enrichies, noix",
      deficiency: "Inflammation de la bouche et des lèvres, inflammation de la langue, fissures aux coins de la bouche, dermatite, sensibilité des yeux à la lumière, anémie",
    },
    b3: {
      importance: "La niacine (B3) contribue à la conversion des aliments en énergie. Elle soutient la santé de la peau, du système nerveux et du système digestif. Elle aide à réduire le mauvais cholestérol.",
      sources: "Viandes rouges, poulet, poisson, foie, cacahuètes, légumineuses, céréales complètes enrichies, champignons, pommes de terre",
      deficiency: "Fatigue et maux de tête, diarrhée, éruptions cutanées, confusion et pertes de mémoire, dans les cas graves : pellagre",
    },
    b5: {
      importance: "L'acide pantothénique (B5) contribue à la conversion des aliments en énergie. Il soutient la santé de la peau, des cheveux et des yeux. Il joue un rôle dans la synthèse des hormones et du cholestérol.",
      sources: "Viandes, foie, poulet, poissons, œufs, lait, champignons, avocat, patate douce, brocoli, légumineuses",
      deficiency: "Très rare, mais peut causer : fatigue, insomnie, dépression, irritabilité, engourdissements dans les pieds, douleurs d'estomac",
    },
    b6: {
      importance: "La pyridoxine (B6) joue un rôle dans la conversion des aliments en énergie. Elle soutient les fonctions cérébrales et le système nerveux. Elle contribue à la synthèse de l'hémoglobine. Elle aide à réguler l'humeur et le sommeil.",
      sources: "Poulet, poisson, bœuf, foie, pommes de terre, bananes, pois chiches, céréales complètes enrichies, épinards, noix",
      deficiency: "Anémie, éruption cutanée, gerçures sur les lèvres, inflammation de la langue, dépression et irritabilité, affaiblissement du système immunitaire, confusion",
    },
    b7: {
      importance: "La biotine (B7) aide à convertir les aliments en énergie. Elle soutient la santé de la peau, des cheveux et des ongles. Elle joue un rôle dans la synthèse des acides gras et du glucose.",
      sources: "Jaune d'œuf, foie, noix (surtout amandes), graines, saumon, avocat, patate douce, épinards, brocoli",
      deficiency: "Chute de cheveux, éruptions cutanées autour des yeux, du nez et de la bouche, ongles cassants, fatigue, dépression, engourdissements dans les extrémités",
    },
    b9: {
      importance: "L'acide folique (B9) est très important pour la formation des globules rouges et la croissance cellulaire. Il est particulièrement essentiel pour les femmes enceintes afin de prévenir les malformations du tube neural chez le fœtus.",
      sources: "Légumes verts à feuilles (épinards, chou), légumineuses (lentilles, haricots), agrumes, avocat, brocoli, céréales enrichies, foie",
      deficiency: "Anémie mégaloblastique, fatigue et faiblesse, aphtes et inflammation de la langue, grisonnement prématuré, chez les femmes enceintes : risque de malformations fœtales",
    },
    b12: {
      importance: "La cobalamine (B12) est nécessaire à la formation des globules rouges et à la santé du système nerveux. Elle aide à produire et réparer l'ADN. Elle renforce la capacité de l'organisme à utiliser les graisses et les protéines.",
      sources: "Viandes, foie, poissons, œufs, lait et produits laitiers, céréales enrichies (pour végétariens), levure alimentaire enrichie",
      deficiency: "Anémie sévère, fatigue et faiblesse, picotements et engourdissements dans les mains et les pieds, problèmes d'équilibre et de marche, problèmes de mémoire et de concentration, inflammation de la langue",
    },
    choline: {
      importance: "La choline est importante pour la santé du cerveau, de la mémoire et du foie. Elle aide à synthétiser les neurotransmetteurs importants pour la mémoire et l'humeur. Elle joue un rôle dans la croissance cellulaire.",
      sources: "Œufs (surtout le jaune), foie, saumon, poulet, viandes rouges, brocoli, choux de Bruxelles, cacahuètes, soja",
      deficiency: "Dommages hépatiques, stéatose hépatique, dommages musculaires, troubles de la mémoire, problèmes de développement neurologique chez l'enfant",
    },
  };
  const currentVitaminInfo = vitaminInfo[normalizedVitamin] || vitaminInfo["a"];
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} SCHEMA={generateSchemaData()} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "12px" }}>
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                Bienvenue dans la <strong>calculatrice {vitaminName}</strong> ! Grâce à cet outil précis, vous pouvez calculer la dose quotidienne optimale de {vitaminName} selon votre âge, votre sexe et votre état de santé. Que vous soyez un homme ou une femme, un enfant ou un adulte, enceinte ou allaitante, notre calculatrice vous fournit des recommandations précises pour garantir que vous obtenez la quantité optimale de {vitaminName}.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>Calculez vos besoins en {vitaminName}</h2>
                </div>
                <form onSubmit={handleCalculate}>
                  <div className="form-group mb-3">
                    <label htmlFor="age"><strong>Âge (en années) :</strong></label>
                    <input type="number" className="form-control" id="age" value={age} onChange={(e) => setAge(e.target.value)} placeholder="Entrez votre âge" min="0" max="120" required />
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="sex"><strong>Sexe :</strong></label>
                    <select className="form-control" id="sex" value={sex} onChange={(e) => { setSex(e.target.value); if (e.target.value === "male") { setIsPregnant(false); setIsLactating(false); } }}>
                      <option value="male">Homme</option>
                      <option value="female">Femme</option>
                    </select>
                  </div>
                  {sex === "female" && (
                    <>
                      <div className="form-group mb-3">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="pregnant" checked={isPregnant} onChange={(e) => { setIsPregnant(e.target.checked); if (e.target.checked) setIsLactating(false); }} />
                          <label className="form-check-label" htmlFor="pregnant">Enceinte</label>
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="lactating" checked={isLactating} onChange={(e) => { setIsLactating(e.target.checked); if (e.target.checked) setIsPregnant(false); }} />
                          <label className="form-check-label" htmlFor="lactating">Allaitante</label>
                        </div>
                      </div>
                    </>
                  )}
                  <hr />
                  <div className="d-flex gap-2">
                    <button type="submit" className="btn bg-success text-white" style={{ fontSize: "16px", padding: "10px 30px" }}>Calculer</button>
                    <button type="button" className="btn btn-secondary" onClick={handleReset} style={{ fontSize: "16px", padding: "10px 30px", marginRight: "10px" }}>Effacer</button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-4">
                {error && (
                  <div className="alert alert-warning" role="alert">
                    <strong>Erreur :</strong> {error}
                  </div>
                )}
                {dose !== null && !error && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>Résultat</h3>
                    </div>
                    <div className="alert alert-success" style={{ fontSize: "16px", lineHeight: "1.8" }}>
                      <h4 style={{ fontSize: "17px", marginBottom: "15px" }}>Dose quotidienne recommandée :</h4>
                      <div style={{ textAlign: "center", padding: "20px", backgroundColor: "#d4edda", borderRadius: "8px", marginBottom: "15px" }}>
                        <div style={{ fontSize: "18px", marginBottom: "10px" }}>
                          <strong>{vitaminName}</strong>
                        </div>
                        <div style={{ fontSize: "32px", fontWeight: "bold", color: "#155724" }}>
                          {dose} {vitaminUnit}
                        </div>
                      </div>
                      <div style={{ fontSize: "14px", marginTop: "15px" }}>
                        <strong>Remarque :</strong>
                        <ul style={{ marginTop: "10px", lineHeight: "1.6" }}>
                          <li>Cette dose représente l'apport journalier recommandé (AJR)</li>
                          <li>Vos besoins réels peuvent varier selon votre état de santé et votre alimentation</li>
                          <li>Consultez votre médecin avant de prendre des compléments alimentaires</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="alert alert-info" style={{ fontSize: "15px", lineHeight: "1.8" }}>
              Vous pouvez également utiliser la <a href="/calculator/fr/vitamin-daily-dose/">calculatrice de la dose quotidienne de vitamines</a> pour calculer la dose quotidienne de différentes vitamines.
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Importance de la {vitaminName}</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>{currentVitaminInfo.importance}</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Pourquoi avez-vous besoin de {vitaminName} ?</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Soutien des fonctions corporelles essentielles et vitales</li>
                  <li>Renforcement de la santé générale et prévention des maladies</li>
                  <li>Garantie de la croissance et du développement normaux</li>
                  <li>Amélioration de la qualité de vie et de l'énergie quotidienne</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Sources naturelles de {vitaminName}</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>La meilleure façon d'obtenir de la {vitaminName} est par une <strong>alimentation équilibrée</strong>. Voici les principales sources naturelles :</p>
                <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                  <h4 style={{ fontSize: "16px", marginBottom: "10px" }}><strong>Sources alimentaires riches en {vitaminName} :</strong></h4>
                  <p>{currentVitaminInfo.sources}</p>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Conseils pour obtenir de la {vitaminName} :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Consommez une grande variété d'aliments frais chaque jour</li>
                  <li>Maintenez une alimentation équilibrée comprenant tous les groupes d'aliments</li>
                  <li>Évitez la cuisson excessive qui peut réduire la valeur des vitamines</li>
                  <li>Consultez votre médecin si vous pensez avoir besoin de compléments alimentaires</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Symptômes d'une carence en {vitaminName}</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Une carence en {vitaminName} peut entraîner de multiples problèmes de santé. Il est important de reconnaître les symptômes tôt :</p>
                <div className="alert alert-warning" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                  <h4 style={{ fontSize: "16px", marginBottom: "10px" }}><strong>Signes et symptômes de carence :</strong></h4>
                  <p>{currentVitaminInfo.deficiency}</p>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Prévention de la carence :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Suivez une alimentation équilibrée et riche en vitamines</li>
                  <li>Utilisez la calculatrice de vitamines pour connaître vos besoins quotidiens</li>
                  <li>Effectuez des bilans réguliers de vos niveaux de vitamines</li>
                  <li>Consultez votre médecin si vous présentez des symptômes de carence</li>
                </ul>
                <div className="alert alert-danger mt-3" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                  <strong>⚠️ Quand consulter un médecin ?</strong>
                  <ul style={{ marginTop: "10px" }}>
                    <li>Si vous souffrez de symptômes persistants de carence en vitamines</li>
                    <li>Avant de prendre des compléments alimentaires à doses élevées</li>
                    <li>Si vous êtes enceinte ou envisagez une grossesse</li>
                    <li>Si vous suivez un régime alimentaire restrictif</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default VitaminDoseCalculator;
